import * as React from 'react';
import { useState } from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import {
    Grid,
    TextField
} from '@mui/material';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from '@mui/material';
import { useCurrentInstanceType } from '../Helper';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

/**
 * Modify ASG Component
 * @param {*} param0 
 * @returns 
 */
export default function ModifyASG({ handleClose, onSave, instanceData }) {

    const [desireCount, setDesireCount] = useState(instanceData?.[0]?.['DesiredCapacity'] ?? 0);
    const [minimumCount, setMinimumCount] = useState(instanceData?.[0]?.['MinSize'] ?? 0);

    const { type } = useCurrentInstanceType()

    return (
        <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={true}
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                <Typography fontWeight={550} color={'#50394c'} >
                    {type === 'vmss' ? 'Scale Down' : 'Modify ASG'}
                </Typography>
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent dividers>
                <Grid container xs={12} spacing={1} >
                    <Grid item xs={12} width={'100%'}>
                        <TableContainer style={{
                            backgroundColor: '#f4e1d2'
                        }}>
                            <Table size='small'>
                                <TableHead>
                                    {instanceData && (
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 550 }}>Instance</TableCell>
                                            {/* <TableCell sx={{ fontWeight: 550 }}>Status</TableCell> */}
                                        </TableRow>
                                    )}
                                </TableHead>
                                <TableBody>
                                    {instanceData && instanceData.map(item => (
                                        <TableRow key={item['id']}>
                                            <TableCell>{['rds', 'asg'].includes(type) ? item['id'] : item['name']}</TableCell>
                                            <TableCell>{['vmss'].includes(type) ? item['vmssName'] : item['vmssName']}</TableCell>
                                            {/* <TableCell>{type === 'rds' ? item['Status'] : item['instanceState'] ?? ''}</TableCell> */}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>

                {type !== 'vmss' && (<Grid container xs={12} spacing={1} style={{
                    marginTop: '20px'
                }} >
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            readonly
                            disabled
                            label="Maximum Size"
                            size='small'
                            type='number'
                            value={instanceData?.[0]?.['MaxSize']}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Minimum Size"
                            size='small'
                            type='number'
                            value={minimumCount}
                            onChange={(e) => setMinimumCount(prev => {
                                return (e['target']['value'] < 0) ? 0 : e['target']['value']
                            })}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Desire Capacity"
                            size='small'
                            type='number'
                            value={desireCount}
                            onChange={(e) => setDesireCount(prev => {
                                return (e['target']['value'] < 0) ? 0 : e['target']['value']
                            })}
                        />
                    </Grid>
                </Grid> )}

                {['vmss'].includes && <Grid container xs={12} spacing={1} style={{
                    marginTop: '20px'
                }} >
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            readonly
                            disabled
                            label="Maximum Capacity"
                            size='small'
                            type='number'
                            value={instanceData?.[0]?.['maxCapacity']}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Minimum Capacity"
                            size='small'
                            type='number'
                            value={minimumCount}
                            onChange={(e) => setMinimumCount(prev => {
                                return (e['target']['value'] < 0) ? 0 : e['target']['value']
                            })}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Desire Capacity"
                            size='small'
                            type='number'
                            value={desireCount}
                            onChange={(e) => setDesireCount(prev => {
                                return (e['target']['value'] < 0) ? 0 : e['target']['value']
                            })}
                        />
                    </Grid>
                </Grid>}

            </DialogContent>
            <DialogActions>
                <Button
                    style={{
                        color: '#fff',
                        backgroundColor: '#50394c',
                        textTransform: 'none'
                    }}
                    onClick={() => onSave({
                        desireCount,
                        minimumCount
                    })}
                    variant='outlined'
                >
                    Save
                </Button>
            </DialogActions>
        </BootstrapDialog>
    );
}